<div class="search-results-page">
  <div class="search-header">
    <h2>Search Results</h2>
    <div class="search-bar">
      <input
        type="text"
        pInputText
        [(ngModel)]="query"
        (ngModelChange)="onSearchInput()"
        placeholder="Search"
        class="search-input"
      />
      <button pButton icon="pi pi-search" (click)="onSearchInput()" class="search-button"></button>
    </div>
  </div>

  <div *ngIf="loading" class="loading">
    <p-progressSpinner></p-progressSpinner>
  </div>

  <div *ngIf="!loading && results.length > 0" class="results-info">
    {{ total }} result{{ total !== 1 ? 's' : '' }} for "{{ query }}"
  </div>

  <div *ngIf="!loading && !failed && results.length === 0 && query" class="no-results">
    No results found for "{{ query }}"
  </div>

  <div *ngIf="!loading && failed && query" class="no-results">
    Search failed. Check your connection or permissions, then try again.
  </div>

  <div class="results-list">
    <div
      *ngFor="let result of results"
      class="result-item"
      tabindex="0"
      role="button"
      (click)="openJob(result)"
      (keydown.enter)="openJob(result)"
      (keydown.space)="openJob(result)"
    >
      <div class="result-icon">
        <i class="pi pi-briefcase"></i>
      </div>
      <div class="result-content">
        <app-search-job-result [result]="result"></app-search-job-result>
      </div>
      <div class="result-right">
        <app-job-status-pill
          *ngIf="result.state"
          [state]="result.state"
          [stage]="result.stage"
        ></app-job-status-pill>
        <div *ngIf="result.zoneName" class="result-zone">{{ result.zoneName }}</div>
      </div>
    </div>
  </div>

  <div *ngIf="results.length > 0 && results.length < total" class="load-more">
    <button pButton (click)="loadMore()" label="Load More Results"></button>
  </div>
</div>